// ---------------------------------------------------------

import Component from './component';
import transform from './transformer';

// ---------------------------------------------------------

const CategoryPosts = (props) => <Component {...transform(props)} />;

export default CategoryPosts;

// ---------------------------------------------------------

export { Component as component, transform as transformer };
